import { useQueueMessages } from "./queue-messages-hooks";
import { createContext, useContext } from "react";

type ContextQueueMessagesType = ReturnType<typeof useQueueMessages>;
const ContextQueueMessages = createContext<ContextQueueMessagesType | null>(
  null,
);

export function useContextQueueMessage() {
  const context = useContext(ContextQueueMessages);

  if (!context) {
    throw new Error(
      "useContextQueueMessage must be used within a ContextQueueMessagesProvider",
    );
  }

  return context;
}

export function ContextQueueMessagesProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useQueueMessages();

  return (
    <ContextQueueMessages.Provider value={value}>
      {children}
    </ContextQueueMessages.Provider>
  );
}
